<template>
  <article>
    <router-link :to="{name: 'compilations.show', params: {id: compilation.id}}" class="block hover:bg-gray-50">
      <div class="flex items-center px-4 py-4 sm:px-6">
        <div class="min-w-0 flex-1 flex items-center">
          <div class="flex-shrink-0">
            <div class="flex justify-center items-center bg-gray-100 w-12 h-12 rounded-md">
              <Twemoji v-if="compilation.emoji" :code="compilation.emoji" class="w-8 h-8" />
              <Twemoji v-else="compilation.emoji" code="2753" class="w-6 h-6" />
            </div>
          </div>
          <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-1 md:gap-4">
            <div>
              <p class="text-sm font-medium text-teal-600 truncate">
                {{ compilation.title }}
              </p>
              <p class="mt-2 flex items-center text-sm text-gray-500">
                <span v-if="edition" class="tag mr-2">
                  Edition
                </span>
                <span v-if="playbook" class="tag mr-2">
                  Playbook
                </span>
                <span class="tag">
                  {{ compilation.num_practices }} Methoden
                </span>
              </p>
            </div>
          </div>
        </div>
        <div>
          <ChevronRightIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
        </div>
      </div>
    </router-link>
  </article>
</template>

<script setup>
import { computed } from 'vue';

const TYPE_EDITION = "edition";
const TYPE_PLAYBOOK = "playbook";

const props = defineProps({compilation: Object});

const type = computed(() => props.compilation.type.key);
const edition = computed(() => type.value == TYPE_EDITION);
const playbook = computed(() => type.value == TYPE_PLAYBOOK);

</script>


<style scoped>
.tag
{
  @apply rounded-full;
  @apply px-2 py-1;
  @apply text-xs font-medium;
  @apply text-gray-800;
  @apply bg-gray-200;
};
</style>
